<template>
  <div>
    <h3>Game server info</h3>

    <template v-if="info !== null">
      <table class="props-compact mb-4">
        <tr>
          <th>Time</th>
          <td>{{info.time | getMomentStr}}</td>
        </tr>
        <tr>
          <th>constant.GAME_VERSION</th>
          <td>{{info.gameVersion}}</td>
        </tr>
        <tr>
          <th>constant.GAME_REVISION_HASH</th>
          <td>{{info.revisionHash}}</td>
        </tr>
        <tr>
          <th>constant.IS_DEV</th>
          <td>{{info.isDev}}</td>
        </tr>
        <tr>
          <th>constant.STATIC_ROOTS</th>
          <td>
            <static-root-list :staticRoots="info.staticRoots"/>
          </td>
        </tr>
        <tr>
          <th>Runtime version</th>
          <td>{{info.runtimeVersion}}</td>
        </tr>
        <tr>
          <th>Hostname</th>
          <td>{{info.hostname}}</td>
        </tr>
        <tr>
          <th>Scheduler hostname</th>
          <td>{{info.schedulerHostname}}</td>
        </tr>
        <tr>
          <th>ConfMgr version</th>
          <td>{{info.confMgrPathVersion}} (bundle: {{info.confMgrBundleVersion}})</td>
        </tr>
      </table>
    </template>

    <loading-indicator
      v-if="isLoading"
    />
  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';

import LoadingIndicator from './LoadingIndicator.vue';
import StaticRootList from './StaticRootList.vue';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'SystemInfoGameServer',

  components: {
    LoadingIndicator,
    StaticRootList,
  },

  data() {
    return {
      loadState: LOAD_STATE_INIT,

      info: null,
    };
  },

  computed: {
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },
  },

  created() {
    this.loadInfo();
  },

  methods: {
    loadInfo() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      HTTP.get('/game_server_info')
      .then(response => {
        this.info = response.data.data;
        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(e => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },
};
</script>

<style scoped>
th {
  vertical-align: top;
}
</style>
